import axios from '../utils/axios';

export default function submitChatgptRating(adminId, type) {
    return axios.post(`/admin/${adminId}/sendotp/${type}`, {});
}
